import { render, staticRenderFns } from "./CampaignDetail.vue?vue&type=template&id=03eab416&scoped=true"
import script from "./CampaignDetail.vue?vue&type=script&lang=js"
export * from "./CampaignDetail.vue?vue&type=script&lang=js"
import style0 from "./CampaignDetail.vue?vue&type=style&index=0&id=03eab416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03eab416",
  null
  
)

export default component.exports